import React, { Component } from 'react';
import {Button, Flex, List, Toast} from 'antd-mobile';
import send from '../../../utils/send_init';
import ReactDOM from 'react-dom';
import InputNumber from '../../../components/InputNumber';
const  TITLE = {
  feed: '饲料',
  medicine: '兽药',
  vaccine:'疫苗',
  semen:'精液',
  pig:'肥猪',
  fswine:'母猪',
  mswine:'公猪',
  cpig:'仔猪'
};
export default class Product extends Component {
  constructor (props) {
    super(props);
    this.state = {
      list:{
        feed:[],
        medicine:[],
        vaccine:[],
        semen:[],
        pig:[],
        fswine:[],
        mswine:[],
        cpig:[]
      }
    }
  }
  componentWillUnmount() {
    console.log('进入产品');
    this.setState = () => false
  }
  componentDidMount() {
    this.getProduct()
  }
  getProduct = () => {
    send({
      url: '/api/forward/ifarm/initInfo/init',
      method: 'get'
    }).then(res => {
      this.setState({
        list: {
          feed:[],
          medicine:[],
          vaccine:[],
          semen:[],
          pig:[],
          fswine:[],
          mswine:[],
          cpig:[],
          ...res.data.data
        }
      })
    }).catch(()=>{})
  };
  onFocus = (ref = 'feed0') => {
    console.log(ReactDOM.findDOMNode(this.refs[ref]).children[0].childNodes[1].childNodes[0]);
    ReactDOM.findDOMNode(this.refs[ref]).children[0].childNodes[1].childNodes[0].focus()
  };
  renderList = (type) => {
    const {autoFocus, list} = this.state;
    console.log(1111111111,list[type], type);
    if (list[type].length > 0) {
      return <List renderHeader={() => TITLE[type]}>
        {list[type].map((item,index) => (
          <InputNumber key={index}
              className={(this.state.mask && index === 0) ? 'topShow w-10 text-right text-3' : 'text-right text-3'}
              pattern="[0-9]*"
              ref={type + index}
              placeholder={'0'}
              labelNumber={15}
              precision={2}
              value={item.num || ''}
              autoFocus={(type+index) === autoFocus ? 'autoFocus': ''}
              extra={item.unitName}
              onFocus={this.doAutoFocus}
              onKeyUp={e => {
                         if(e.keyCode === 13) {
                           if (index < list.length - 1) {
                             let id = type + (index + 1);
                             this.setState({
                               autoFocus: id,
                               mask: false
                             });
                             ReactDOM.findDOMNode(this.refs[id]).childNodes[0].children[1].children[0].focus()
                           } else {
                             const ref = type + index;
                             ReactDOM.findDOMNode(this.refs[ref]).childNodes[0].children[1].children[0].blur();
                             Toast.info('别保存')
                           }
                         }
                       }
                       }
              onChange={v => {
                         this.setState(state => {
                           item.num = v;
                           return state;
                         })
                       }}

          >
            <Flex>
              <span>{item.productName}</span>
              <div className={'bag'}>{item.unitName}</div>
            </Flex>
          </InputNumber>
        ))}
      </List>
    }
  };
  render() {
  return (
    <React.Fragment>

      {this.renderList('feed')}

    </React.Fragment>
  )
 }
}
